import { Card, Font, Icon } from "pepsico-ds";
import "./BuilderDocumentCard.css";
import { Box, Tooltip, Typography, useMediaQuery } from "@mui/material";
import { truncateText } from "../../../../../utils/function";
import AccordionDetail from "../../SpecialProject/AccordionDetail";
import {
  setSummaryDetails,
  setViewPageName,
  setViewSummaryDrawer,
} from "../../../../../slices/viewSummarySlice";
import { useDispatch } from "react-redux";
import { removeAssociatedContent } from "../../../../../slices/forumBuilderSlice";
import useThemeRender from "../../../../../theme/useThemeRender";

const BuilderDocumentCard = ({ label, item, type, handleDeleteContent }) => {
  const insideCardBackgroundColorLayer6 = useThemeRender(
    "insideCardBackgroundColorLayer6"
  );

  const textColorLayer2 = useThemeRender("textColorLayer2");
  const isMobile = useMediaQuery("(max-width:920px)");
  const verySmall = useMediaQuery("(max-width:400px)");
  const dispatch = useDispatch();
  const handleViewSummary = () => {
    dispatch(setViewSummaryDrawer(true));
    dispatch(setSummaryDetails(item));
    dispatch(setViewPageName(label));
  };

  const handleDete = (e, value) => {
    if (handleDeleteContent) {
      handleDeleteContent(value.contentId);
    } else {
      dispatch(
        removeAssociatedContent({ contentType: type, id: value.contentId })
      );
    }
  };

  return (
    <Card
      border
      ellipsis={false}
      icon={null}
      title={null}
      isDark={true}
      style={{
        width: verySmall ? "83%" : isMobile ? "100%" : "388px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? "8px" : "",
        }}
      >
        <Tooltip title={item.title} arrow disableInteractive>
          <span
            style={{
              display: "flex",
              justifyContent: isMobile ? "center" : "",
            }}
          >
            <Font headingLevel={6}>
              {truncateText(item.title, verySmall ? 5 : 20)}
            </Font>
          </span>
        </Tooltip>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "var(--Spacing-spacing-24, 24px)",
          }}
        >
          <Icon
            icon="delete"
            style={{ cursor: "pointer" }}
            onClick={(e) => handleDete(e, item)}
          />
          <Icon
            icon="preview"
            style={{ cursor: "pointer" }}
            onClick={handleViewSummary}
          />
        </Box>
      </Box>
      <Font
        className="summary"
        style={{
          fontSize: "14px",
          fontWeight: "500",
          color: "#000",
          lineHeight: "20px",
        }}
      >
        {truncateText(item?.summary, 200)}
      </Font>

      {item?.subject?.length > 0 && (
        <AccordionDetail
          header="Subject"
          data={item?.subject?.slice(0, 3)?.map((name) => ({ name: name }))}
        >
          {item?.subject?.length > 3 && (
            <Box
              sx={{
                display: "flex",
                padding:
                  "var(--Spacing-spacing-4, 4px) var(--Spacing-spacing-02, 4px)",
                alignItems: "center",
                gap: "2px",
                borderRadius: "var(--Corner-radius-effect-corner-1, 4px)",
                background: insideCardBackgroundColorLayer6,
              }}
            >
              <Typography
                sx={{
                  color: textColorLayer2,
                  fontFeatureSettings: "'liga' off, 'clig' off",
                  fontFamily: "Inter",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: 400,
                  lineHeight: "133%",
                }}
              >
                +{item?.subject?.length - 2} more
              </Typography>
            </Box>
          )}
        </AccordionDetail>
      )}
    </Card>
  );
};

export default BuilderDocumentCard;
